import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { IMapRiskInfo } from 'src/app/core/models/front';
import { IRisksDataMapService } from 'src/app/core/services/core';
import { SubSink } from 'subsink';

@Component({
  selector: 'howden-risks-selection',
  templateUrl: './risks-selection.component.html',
  styleUrls: ['./risks-selection.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatTableModule
  ]
})
export class RisksSelectionComponent implements OnInit, OnDestroy {
  private dataRiskMapSrv = inject(IRisksDataMapService);

  public displayedColumns: string[] = ['riskId', 'categoryDesc', 'description', 'probability', 'impact', 'order'];
  public riskSelected: Array<any> = [];
  public dataSource = new MatTableDataSource(this.riskSelected);
  public selection = new SelectionModel<any>(true, []); // Para poder ordenar las columnas

  private _subscriptions = new SubSink();

  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  ngOnInit() {
    this._subscriptions = this.dataRiskMapSrv.getDataRiskMapEmitter().subscribe((data: Array<IMapRiskInfo>) => {
      this.updateSelectedRisks(data);
    });
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  updateSelectedRisks(dataRiskMap: Array<IMapRiskInfo>) {
    this.riskSelected = [];

    dataRiskMap.forEach((x) => {
      x.risks.forEach((r) => {
        this.riskSelected.push({
          riskId: r.riskId,
          description: r.description,
          categoryDesc: r.categoryDesc,
          probability: x.probability,
          impact: x.impact,
          order: x.order,
          color: x.color
        });
      });
    });

    this.dataSource = new MatTableDataSource(this.riskSelected);
    this.dataSource.sort = this.sort;
  }
}
